import { Directive } from '@angular/core';

/**
 * Marks the `<ng-template>` that holds a schedule item's tooltip content. The
 * base item renders it only when the tooltip opens, so the tooltip's
 * components are never built for items nobody hovers.
 */
@Directive({
  selector: 'ng-template[scheduleItemTooltip]',
})
export class ScheduleItemTooltipTemplateDirective {}
